<template>
  <div class="images">
    <div class="images__left" @click="goLeft()"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
    <div class="images__main" @click="showLightbox = true"><img :src="mainImage" alt=""></div>
    <div class="images__right" @click="goRight()"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
    <!-- <div class="images__pager">
      <span class="images__page" v-for="page in pages"><i class="fa fa-circle"></i></span>
    </div> -->
    <transition name="lightbox">
      <div class="lightbox" v-show="showLightbox">
        <div class="lightbox-body">
          <div class="lightbox-body__close" @click="showLightbox = false"><i class="fa fa-times" aria-hidden="true"></i></div>
          <div class="lightbox-body__left" @click="goLeft()"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>
          <div class="lightbox-body__image"><img :src="mainImage" alt=""></div>
          <div class="lightbox-body__right" @click="goRight()"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WorkImages',
  computed: {
    pages () {
      let pages = []
      for (let i = 0; i < this.images.length; i++) {
        pages.push(i)
      }
      return pages
    },
    mainImage () {
      return this.images[this.currentImage]
    }
  },
  data () {
    return {
      currentImage: 0,
      showLightbox: false
    }
  },
  methods: {
    goLeft () {
      if (this.currentImage - 1 >= 0) {
        this.currentImage--
      } else {
        this.currentImage = this.images.length - 1
      }
    },
    goRight () {
      if (this.currentImage + 1 < this.images.length) {
        this.currentImage++
      } else {
        this.currentImage = 0
      }
    }
  },
  props: {
    images: {
      type: Array,
      required: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$black: #2c3e50;
$green: #41BAA4;
$green-dark: #067e76;

.lightbox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background-color: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
}

.lightbox-body {
  &__close {
    color: #fff;
    position: fixed;
    top: 50px;
    right: 50px;
    font-size: 52px;
    z-index: 1002;
    cursor: pointer;
  }
  &__left {
    position: fixed;
    width: 20vw;
    top: 0;
    left: 0;
    line-height: 100vh;
    height: 100vh;
    color: #fff;
    font-size: 48px;
    cursor: pointer;
  }
  &__image {
    width: 60vw;
    height: 100vh;
    position: fixed;
    left: 20vw;
    top: 0;
    img {
      box-sizing: border-box;
      max-width: 100%;
      max-height: 100%;
      position: relative;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
  }
  &__right {
    position: fixed;
    width: 20vw;
    top: 0;
    right: 0;
    line-height: 100vh;
    height: 100vh;
    color: #fff;
    font-size: 48px;
    cursor: pointer;
  }
}

.lightbox-enter-active, .lightbox-leave-active {
  transition: opacity .5s;
}
.lightbox-enter, .lightbox-leave-to {
  opacity: 0;
}

.images {
  display: block;
  height: calc(80vw * 0.8 / 16 * 9);
  margin-bottom: 30px;
  width: 80vw;
  position: relative;
  left: -10vw;
  &__left {
    width: 10%;
    float: left;
    line-height: calc(80vw * 0.8 / 16 * 9);
    cursor: pointer;
    transition: .3s;
    &:hover {
      color: $green-dark;
    }
  }
  &__right {
    width: 10%;
    float: left;
    line-height: calc(80vw * 0.8 / 16 * 9);
    cursor: pointer;
    transition: .3s;
    &:hover {
      color: $green-dark;
    }
  }
  &__main {
    width: 80%;
    float: left;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    img {
      max-height: calc(80vw * 0.8 / 16 * 9);
      max-width: calc(80vw * 0.8);
      // border: solid 1px $green;
      // border-radius: 2px;
      height: auto;
      width: auto;
    }
  }
  &__pager {
    font-size: 18px;
    font-weight: bold;
  }
  &__page {
    cursor: pointer;
    margin-right: 10px;
  }
}

@media screen and (max-width: 767px) {
  .lightbox-body {
    &__left {
      width: 15vw;
      z-index: 1001;
    }
    &__right {
      width: 15vw;
      z-index: 1001;
    }
    &__image {
      width: 70vw;
      z-index: 1001;
      left: 15vw;
    }
  }
  .images {
    width: 100vw;
    left: 0;
  }
}


</style>



// WEBPACK FOOTER //
// WorkImages.vue?14063e2b